<template>
  <div id="full" class="screen-container" @dblclick="full">
    <div class="header clearfix" />
    <div class="main">
      <el-row :gutter="15" class="height100">
        <el-col :span="6" class="height100">
          <div class="column-flex space-between">
            <section>
              <h4 class="title">电量产出</h4>
              <div class="content chart-content row-flex">
                <PieChart :data="power.rate" style="width:60%" :unit="power.rateUnit" />
                <div class="flex-grow column-flex space-around text-info">
                  <p class="yellow"><b>本日发电量</b> <br>
                    <span>
                      {{ tvdata.daySolar | objValue(['cvalue'], 0) }}
                      {{ tvdata.daySolar | objValue(['cvalue'], 1) }}
                    </span>
                  </p>
                  <p class="yellow"><b>本日自发自用电量</b> <br>
                    <span>
                      {{ tvdata.daySelfUse | objValue(['cvalue'], 0) }}
                      {{ tvdata.daySelfUse | objValue(['cvalue'], 1) }}
                    </span>
                  </p>
                  <p class="blue"><b>本月发电量</b> <br>
                    <span>
                      {{ tvdata.monthSolar | objValue(['cvalue'], 0) }}
                      {{ tvdata.monthSolar | objValue(['cvalue'], 1) }}
                    </span>
                  </p>
                </div>
              </div>
            </section>
            <section>
              <h4 class="title">电量买入</h4>
              <div class="content chart-content row-flex">
                <PieChart :data="power.buy" style="width:60%" :unit="power.buyUnit" />
                <div class="flex-grow column-flex space-around text-info">
                  <p class="yellow"><b>本日买电量</b> <br>
                    <span>
                      {{ tvdata.dayBuy | objValue(['cvalue'], 0) }}
                      {{ tvdata.dayBuy | objValue(['cvalue'], 1) }}
                    </span>
                  </p>
                  <p class="blue"><b>本月买电量</b> <br>
                    <span>
                      {{ tvdata.monthBuy | objValue(['cvalue'], 0) }}
                      {{ tvdata.monthBuy | objValue(['cvalue'], 1) }}
                    </span>
                  </p>
                </div>
              </div>
            </section>
            <section>
              <h4 class="title">电量卖出</h4>
              <div class="content chart-content row-flex">
                <PieChart :data="power.sale" style="width:60%" :unit="power.saleUnit" />
                <div class="flex-grow column-flex space-around text-info">
                  <p class="yellow"><b>本日卖电量</b> <br>
                    <span>
                      {{ tvdata.daySale | objValue(['cvalue'], 0) }}
                      {{ tvdata.daySale | objValue(['cvalue'], 1) }}
                    </span>
                  </p>
                  <p class="blue"><b>本月卖电量</b> <br>
                    <span>
                      {{ tvdata.monthSale | objValue(['cvalue'], 0) }}
                      {{ tvdata.monthSale | objValue(['cvalue'], 1) }}
                    </span>
                  </p>
                </div>
              </div>
            </section>
          </div>
        </el-col>
        <el-col :span="12" class="height100">
          <div class="column-flex space-between">
            <section class="big relative">
              <h4 class="title">能量平衡</h4>
              <div class="button-group absolute">
                <button :class="dateType === 'month' ? 'active' : ''" @click="changeDataType('month', 0)">月</button>
                <button :class="dateType === 'year' ? 'active' : ''" @click="changeDataType('year', 1)">年</button>
                <button :class="dateType === 'total' ? 'active' : ''" @click="changeDataType('total', 2)">总</button>
              </div>
              <div class="content column-flex space-between relative">
                <div style="margin-top:20px;height:240px">
                  <ToggleChart
                    ref="electricityChartRef"
                    :data="electricityChart.data"
                    :columns="electricityChart.columns"
                    :format="electricityChart.format"
                    :setting="electricityChart.setting"
                    :extend="electricityChart.extend"
                    :loading="electricityChart.loading"
                    :unit="electricityChart.unit"
                  />
                </div>
                <div style="margin-top:20px;height:240px">
                  <ToggleChart
                    ref="powerGenerationChartRef"
                    :data="powerGenerationChart.data"
                    :columns="powerGenerationChart.columns"
                    :format="powerGenerationChart.format"
                    :setting="powerGenerationChart.setting"
                    :extend="powerGenerationChart.extend"
                    :loading="powerGenerationChart.loading"
                    :unit="powerGenerationChart.unit"
                  />
                </div>
              </div>
            </section>
            <el-row class="small-height" :gutter="15">
              <el-col :span="12" class="height100">
                <section class="small">
                  <h4 class="title">发电量 {{ tvdata.totalSolar | objValue(['cvalue'], 0) }}{{ tvdata.totalSolar | objValue(['cvalue'], 1 ) }}</h4>
                  <div class="content row-flex space-around align-center">
                    <bar
                      left-text="发电"
                      right-text="自发自用"
                      :data="power.faData"
                      :data-unit="power.faDataUnit"
                      :color="['#FAB534', '#4C8FF0']"
                    />
                  </div>
                </section>
              </el-col>
              <el-col :span="12" class="height100">
                <section class="small">
                  <h4 class="title">用户用电量 {{ tvdata.totalUse | objValue(['cvalue'], 0) }}{{ tvdata.totalUse | objValue(['cvalue'], 1 ) }}</h4>
                  <div class="content row-flex space-around align-center">
                    <bar
                      left-text="买电"
                      right-text="自发自用"
                      :data="power.yoData"
                      :data-unit="power.yoDataUnit"
                      :color="['#62BE95', '#DC6170']"
                    />
                  </div>
                </section>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="6" class="height100">
          <div class="column-flex space-between">
            <section>
              <h4 class="title">电站信息 <span>{{ time }}</span></h4>
              <div class="content column-flex">
                <h4>{{ tvdata.stationInfo.stationName }}</h4>
                <div class="column-flex flex-grow space-around info">
                  <p><b>电站状态</b> <span>{{ tvdata.stationInfo.status | statusFilter }}</span></p>
                  <p><b>电站类型</b> <span>{{ tvdata.stationInfo.stationCategory }}</span></p>
                  <p><b>并网时间</b> <span>{{ tvdata.stationInfo.gridTime }}</span></p>
                  <p><b>电站地址</b> <span>{{ tvdata.stationInfo.address }}</span></p>
                </div>
              </div>
            </section>
            <section>
              <h4 class="title">等效发电</h4>
              <div class="content column-flex">
                <div class="column-flex flex-grow space-around info">
                  <p style="padding-top: 35px;"><b>装机容量</b>
                    <span style="margin-left: 77px;">
                      {{ tvdata.capacity }} kWp
                    </span>
                  </p>
                  <p><b>日等效发电小时</b> <span>{{ tvdata.dayFull }} h</span></p>
                  <p style="padding-bottom: 35px;"><b>月等效发电小时</b> <span>{{ tvdata.monthFull }} h</span></p>
                </div>
              </div>
            </section>
            <section>
              <h4 class="title">节能减排</h4>
              <div class="content row-flex space-around align-center">
                <div class="text-center info">
                  <el-image :src="require('@/assets/bigscreen/co.png')" />
                  <p>CO2减排</p>
                  <p>
                    {{ tvdata.co2 | objValue(['cvalue'], 0) }}
                    {{ tvdata.co2 | objValue(['cvalue'], 1) }}
                  </p>
                </div>
                <div class="text-center info">
                  <el-image :src="require('@/assets/bigscreen/tree.png')" />
                  <p>等效绿植</p>
                  <p>
                    {{ tvdata.trees | objValue(['cvalue'], 0) }}
                    {{ tvdata.trees | objValue(['cvalue'], 1) }}
                  </p>
                </div>
              </div>
            </section>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import screenfull from 'screenfull/dist/screenfull.js'
import ToggleChart from '@views/Charts/ToggleChart4.vue'
import PieChart from '@views/Charts/PieChart2.vue'
import bar from './component/bar.vue'
export default {
  components: {
    PieChart,
    ToggleChart,
    bar
  },
  props: {
    tvdata: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      power: {
        rate: 0,
        rateUnit: 'kWh',
        buy: 0,
        buyUnit: 'kWh',
        sale: 0,
        saleUnit: 'kWh',
        faData: [],
        yoData: [],
        faDataUnit: [],
        yoDataUnit: []
      },
      time: '',
      timer: null,
      timer1: null,
      dateType: 'month',
      active: 0,

      /**  能量平衡用电图表  */
      electricityChart: {
        loading: false,
        columns: ['time', 'val1', 'val2', 'val3'],
        data: [],
        format: '',
        unit: 'kWh',
        setting: {
          type: '', area: true, labelMap: {
            'val1': '自发自用', 'val2': '买电', 'val3': '用电'
          }
        },
        extend: {
          title: {
            text: '用电',
            right: 40,
            top: 0,
            textStyle: {
              color: '#f8f8f8'
            }
          },
          legend: {
            bottom: 0,
            textStyle: {
              color: '#f8f8f8'
            }
          },
          grid: {
            left: 40,
            right: 40,
            bottom: 30,
            top: 40
          },
        }
      },

      /** 能量平衡发电图表 */
      powerGenerationChart: {
        loading: false,
        columns: ['time', 'val1', 'val2', 'val3'],
        data: [],
        format: '',
        unit: 'kWh',
        setting: {
          type: '', area: true, labelMap: {
            'val1': '自发自用', 'val2': '卖电', 'val3': '发电'
          }
        },
        extend: {
          title: {
            text: '发电',
            right: 40,
            top: 0,
            textStyle: {
              color: '#f8f8f8'
            }
          }
        }
      }
    }
  },
  watch: {
    tvdata: {
      handler: function (val) {
        this.setPower()
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
  },
  created () {
    this.chageData()
    this.setPower()
    this.timer = setInterval(() => {
      this.time = this.$parseTime(new Date(), 'yyyy-MM-dd hh:mm:ss')
    }, 1000)
  },
  mounted () {
    this.timer1 = setInterval(() => {
      const type = ['month', 'year', 'total']
      this.active++
      if (this.active >= 3) {
        this.active = 0
      }
      this.dateType = type[this.active]
      this.changeDataType(this.dateType, this.active)
    }, 30 * 1000)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.timer1) {
      clearInterval(this.timer1)
    }
  },
  methods: {

    setPower () {
      this.power.yoData = [Number(this.tvdata.totalBuy.cvalue[0]), Number(this.tvdata.totalSelfUse.cvalue[0])]
      this.power.yoDataUnit = [this.tvdata.totalBuy.cvalue[1], this.tvdata.totalSelfUse.cvalue[1]]
      this.power.faData = [Number(this.tvdata.totalSale.cvalue[0]), Number(this.tvdata.totalSelfUse.cvalue[0])]
      this.power.faDataUnit = [this.tvdata.totalSale.cvalue[1], this.tvdata.totalSelfUse.cvalue[1]]

      this.power.rate = Number(this.tvdata.totalSolar.cvalue[0])
      this.power.rateUnit = this.tvdata.totalSolar.cvalue[1]
      this.power.buy = Number(this.tvdata.totalBuy.cvalue[0])
      this.power.buyUnit = this.tvdata.totalBuy.cvalue[1]
      this.power.sale = Number(this.tvdata.totalSale.cvalue[0])
      this.power.saleUnit = this.tvdata.totalSale.cvalue[1]
    },

    changeDataType (type, index) {
      this.dateType = type
      this.active = index
      this.chageData()
    },

    full () {
      if (screenfull.isEnabled) {
        screenfull.toggle()
      }
    },

    chageData () {
      this.powerGenerationChart.loading = true
      this.electricityChart.loading = true
      if (this.dateType === 'month') {
        this.electricityChart.setting.type = 'line'
        this.electricityChart.data = this.tvdata.monthUseChart
        this.electricityChart.format = 'yyyy-MM-dd'
        this.electricityChart.loading = false

        this.powerGenerationChart.setting.type = 'line'
        this.powerGenerationChart.data = this.tvdata.monthSolarChart
        this.powerGenerationChart.format = 'yyyy-MM-dd'
        this.powerGenerationChart.loading = false
      } else if (this.dateType === 'year') {
        this.powerGenerationChart.data = this.tvdata.yearSolarChart
        this.electricityChart.data = this.tvdata.yearUseChart
        this.powerGenerationChart.setting.type = 'histogram'
        this.electricityChart.setting.type = 'histogram'
        this.powerGenerationChart.format = 'yyyy-MM'
        this.electricityChart.format = 'yyyy-MM'
        this.powerGenerationChart.loading = false
        this.electricityChart.loading = false
      } else if (this.dateType === 'total') {
        this.powerGenerationChart.data = this.tvdata.totalSolarChart
        this.electricityChart.data = this.tvdata.totalUseChart
        this.powerGenerationChart.setting.type = 'histogram'
        this.electricityChart.setting.type = 'histogram'
        this.powerGenerationChart.format = 'yyyy'
        this.electricityChart.format = 'yyyy'
        this.powerGenerationChart.loading = false
        this.electricityChart.loading = false
      }
    }
  }
}
</script>

<style lang="css" scoped>
.screen-container {
  height: 100vh;
  width: 100vw;
  background-color: #0c1e39;
}

.header {
  height: 100px;
  background: url("../../../../assets/bigscreen/head-mbg.png") center center no-repeat;
}

.main {
  height: calc(100vh - 100px);
}

.main .height100,
.main .column-flex {
  height: 100%;
}

.main .small-height {
  height: calc(30% - 15px);
}

.main section {
  height: calc(33.33% - 10px);
  background: url("../../../../assets/bigscreen/bg2.png") center center no-repeat;
  background-size: 100% 100%;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.main section .title {
  color: #f2f2f2;
  font-size: 20px;
  position: relative;
  padding-left: 15px;
}

.main section .title:before {
  content: '';
  display: inline-block;
  width: 6px;
  background-color: #06cdf8;
  height: 16px;
  border-radius: 4px;
  position: absolute;
  left: 0px;
  top: calc(50% - 8px);
}

.main section .chart-content {
  height: 250px;
}

.main section .content {
  flex-grow: 1;
}

.main section .content h4 {
  color: #e8e8e8;
  font-size: 20px;
  line-height: 40px;
}

.main section .content .info2 {
  color: #e8e8e8;
  font-size: 16px;
  line-height: 30px;
}

.main section .content .info {
  color: #e8e8e8;
  font-size: 16px;
  line-height: 30px;
}

.main section .content .info b {
  font-weight: normal;
}

.main section .content .info span {
  display: inline-block;
  margin-left: 30px;
  color: #598ddb;
}

.main section .content .text-info {
  color: #e8e8e8;
  padding: 30px 0;
  box-sizing: border-box;
  font-size: 18px;
  min-height: 250px;
}

.main section .content .text-info b {
  font-weight: normal;
}

.main section .content .text-info hr {
  width: 100%;
}

.main section .content .text-info .blue {
  background: url("../../../../assets/bigscreen/blue.png") center center no-repeat;
  background-size: 100% 100%;
  padding-left: 20px;
  padding-bottom: 10px;
}

.main section .content .text-info .blue span {
  line-height: 30px;
}

.main section .content .text-info .yellow {
  background: url("../../../../assets/bigscreen/yellow.png") center center no-repeat;
  background-size: 100% 100%;
  padding-left: 20px;
  padding-bottom: 10px;
}

.main section .content .text-info .yellow span {
  line-height: 30px;
}

.main section.small {
  height: 100%;
  background: url("../../../../assets/bigscreen/bg1.png") center center no-repeat;
  background-size: 100% 100%;
}

.main section.big {
  height: 70%;
  background: url("../../../../assets/bigscreen/bg3.png") center center no-repeat;
  background-size: calc(100% + 8px) calc(100% + 8px);
}

* ::v-deep .v-charts-data-empty {
  background-color: transparent;
  color: #fefefe;
}

.button-group {
  right: 20px;
}

.button-group button {
  width: 66px;
  height: 24px;
  line-height: 24px;
  background: url("../../../../assets/bigscreen/button.png") center center no-repeat;
  background-size: 100% 100%;
  color: #f8f8f8;
  outline: none;
  border: none;
}

.button-group button.active {
  background-color: #4f93f7;
}

.button-group button+button {
  margin-left: 10px;
}

.text-title {
  color: #f8f8f8;
  font-size: 18px;
  left: -20px;
  top: calc(50% - 37px);
  transform: rotate(-90deg);
}

.tqyb {
  color: #f8f8f8;
}

.tqyb header {
  font-size: 12px;
  margin-left: 10px;
  color: #598ddb;
}

.tqyb div {
  font-size: 12px;
}

.shade {
  color: #aaa;
}

.sunny {
  color: #fbe251;
}

.cloudy {
  color: #fffffb;
}
</style>
